import { environment as env } from './reins-environment';
import { environment as SDKEvt } from 'ets-fe-ng-sdk';
env.authenticate = true;
export const environment = env;

SDKEvt.reinit(environment);
